export default function simpleSlug(str: string): string {
    return str.toLowerCase().replace(/ /g, '-');
}
